import { render, staticRenderFns } from "./AuCtion.vue?vue&type=template&id=63171f10&scoped=true"
import script from "./AuCtion.vue?vue&type=script&lang=js"
export * from "./AuCtion.vue?vue&type=script&lang=js"
import style0 from "./AuCtion.vue?vue&type=style&index=0&id=63171f10&prod&lang=scss&scoped=true"
import style1 from "./AuCtion.vue?vue&type=style&index=1&id=63171f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63171f10",
  null
  
)

export default component.exports